<template>
  <el-form
    v-if="isAuth"
    :ref="formReference"
    :model="form"
    :rules="rules"
    class="lad-reviews--form"
    @submit.native.prevent="handleValidate"
  >
    <el-form-item prop="message">
      <LadEmojiInput
        :ref="inputReference"
        v-model="form.message"
        :maxlength="255"
        :disabled="loading"
        :placeholder="$t(`${base}.form.placeholders.message`)"
        @enter="handleValidate"
      >
        <el-button
          slot="append"
          :loading="loading"
          icon="el-icon-s-promotion"
          @click="handleValidate"
        ></el-button>
      </LadEmojiInput>
    </el-form-item>
  </el-form>
</template>

<script>
import { uuidv4, hasOwnProperties } from '@/utils'

export default {
  name: 'LadReviewsForm',
  components: {
    LadEmojiInput: () => import('@/components/frontends/Emojis/Input'),
  },
  props: {
    review: { type: Object, required: true },
  },
  data() {
    const base = 'components.reviews.comments'

    /** validando campo obligatorio */
    const requiredField = (rule, value, callback) => {
      let error
      const field = rule.field

      if (value === undefined || value === null || value.length === 0) {
        const name = this.$t(`${base}.form.labels.${field}`)

        error = new Error(
          this.$t(`general.validations.required_input`, { name })
        )
      }

      callback(error)
    }

    /** adiciona mensajes de validacion del servidor */
    const validateServer = (rule, value, callback) => {
      let error
      const field = rule.field

      if (this.serverErrors[field]) {
        const name = this.$t(`${base}.form.labels.${field}`)

        error = new Error(this.serverErrors[field][0].replace(field, name))
      }

      callback(error)
    }

    return {
      formReference: `reviewComment-${uuidv4()}`,
      inputReference: `reviewInput-${uuidv4()}`,
      base,
      loading: false,
      form: {
        message: '',
        type: 'text/plain',
      },
      rules: {
        message: [
          {
            required: true,
            trigger: 'change',
            validator: requiredField,
          },
          { trigger: 'blur', validator: validateServer },
        ],
      },
      serverErrors: {},
    }
  },
  mounted() {
    this.handleFocus()
  },
  methods: {
    handleFocus() {
      if (this.$refs[this.inputReference]) {
        this.$scrollTo(this.$refs[this.inputReference].$el, 300, {
          offset: -400,
        })

        setTimeout(() => {
          this.$refs[this.inputReference].$el
            .getElementsByTagName('input')[0]
            .focus()
        }, 300)
      }
    },
    handleValidate() {
      this.serverErrors = {}

      this.$refs[this.formReference].validate((valid) => {
        if (valid) this.handleSubmit()
      })
    },
    async handleSubmit() {
      this.loading = true

      try {
        const { data, status } = await this.$axios.post(
          `/api/reviews/${this.review.uuid}/comment`,
          this.form
        )

        if (status === 'success') {
          this.$refs[this.formReference].resetFields()
          this.$emit('success', data)
        }
      } catch (error) {
        if (hasOwnProperties(error, 'response.data')) {
          const eData = error.response.data

          if (hasOwnProperties(eData, 'validation_errors')) {
            this.serverErrors = eData.validation_errors
          }

          this.LadNextTick(
            () => this.$refs[this.formReference].validate(() => {}),
            'LadReviewsForm'
          )
        }
      }

      this.loading = false
      this.handleFocus()
    },
  },
}
</script>

<style lang="scss">
.lad-reviews--form {
  .el-form-item {
    margin: 6px 0;
  }
}
</style>
